import React from 'react';
import PageNotFound from './404';
import PaymentMessage from './PaymentMessage';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Error.css';

const Error = props => {
  const query = new URLSearchParams(useLocation().search);
  if (props.type === 'payment') {
    return <PaymentMessage status={query.get('status')} />;
  }
  switch (props.error) {
    case '403':
      return <div>403</div>;
    case '404':
      return <PageNotFound redirectTo={props.redirectTo} />;
    default :
      return <PageNotFound redirectTo={props.redirectTo} />;
  }
};

Error.propTypes = {
  type: PropTypes.string,
  error: PropTypes.string,
  redirectTo: PropTypes.string,
};

export default Error;
